import { UploadEntity } from '@check-list/core/models/upload-entity.model';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { Subject } from 'rxjs';

export interface UploadDirectoryData {
  id: string;
  namePath: string;
  uploadEntity: UploadEntity;
}

export class UploadFile {
  file: NzUploadFile;
  uploadZone: UploadDirectoryData;
  filteredBy: string;
  isCancelled: boolean;
  isReady: boolean;
  message: string;
  uploadDestroyed$: Subject<boolean> = new Subject();

  constructor(file: NzUploadFile, zone: UploadDirectoryData) {
    this.file = file;
    this.uploadZone = {
      namePath: zone.namePath,
      id: zone.id,
      uploadEntity: zone.uploadEntity
    };
  }

  cancelUpload(): void {
    this.isReady = false;
    this.file.percent = 0;
    this.isCancelled = true;
    this.uploadDestroyed$.next(true);
    this.uploadDestroyed$.complete();
    this.message = 'cancelled';
  }

  upload(): void {
    this.isCancelled = false;
    this.uploadDestroyed$ = new Subject();
    this.message = null;
  }

  done() {
    this.uploadDestroyed$.next(true);
    this.uploadDestroyed$.complete();
  }
}
